import { BRAND_LOGOS } from "./brand-images.config";
import { THIRD_PARTY_LOGOS } from "./third-party-logos.config";
import { PROTOCOL_LOGOS } from "./protocol-logos.config";
import { TOKEN_LOGOS } from "./token-logos.config";
import { POINTS_BADGES } from "./points-badges.config";
import { CHAINS_LOGOS } from "./chains.config";

export const IMAGES = {
    ...BRAND_LOGOS,
    ...THIRD_PARTY_LOGOS,
    ...PROTOCOL_LOGOS,
    ...TOKEN_LOGOS,
    ...POINTS_BADGES,
    ...CHAINS_LOGOS,
} as const;
